import { Checkbox, Stack } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import * as React from 'react';
import { IImageThumbnail } from '../../../Models/PhotoGallery/IImageThumbnail';
import { backendUrl } from '../../../Services/ConfigureService';
import { PhotogalleryView } from './PhotogalleryView';
import { IDictionary } from '../../../Models/IDictionary';
interface IPhotogalleryThumbnailsProps {
    thumbnails: IImageThumbnail[];
    selected?: IDictionary<IImageThumbnail>;
    onSelect?: (img: IImageThumbnail) => void;
}

export const PhotogalleryThumbnails: React.FC<IPhotogalleryThumbnailsProps> = props => {
    const [startIndex, setStartIndex] = React.useState<number>(-1);    

    const openPrevew = (index: number) => {
        setStartIndex(index);
    }

    const renderImage = (image: IImageThumbnail, index: number) => {
        return (<div style={{ maxWidth: 200 }}>
            <div>
                <img style={{ width: '100%', display: 'block' }} onClick={() => { setStartIndex(index) }} src={`${backendUrl()}api/PhotoGallery/GeImageThumbnailById/${image.id}`} />
                {props.onSelect && props.selected ? <Checkbox checked={(props.selected[image.id] !== undefined)} onChange={() => props.onSelect && props.onSelect(image)} /> : null}
            </div>
            <span style={{ width:'100%' }}>{image.description}</span>
            </div>);
    }

    const renderList = (images: IImageThumbnail[]) => {
        return images.map((item: IImageThumbnail,index:number) => {
            return renderImage(item,index);
        });
    }

    return (<Stack horizontal tokens={{ childrenGap: 5 }} wrap>
        {renderList(props.thumbnails)}
        {startIndex > -1 ?
            <PhotogalleryView images={props.thumbnails} startIndex={startIndex} onDismiss={() => { setStartIndex(-1) }}></PhotogalleryView>
            : null
        }
    </Stack>)
}